module.exports = __webpack_public_path__ + "img/rato.6ee56aeb.jpg";